<template>
  <section class="lg:py-24 py-12">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-left mb-12 lg:mb-16 max-w-2xl">
        <h2
          class="text-2xl sm:text-3xl md:text-4xl font-heading font-semibold text-gray-900 leading-tight"
        >
          How we provide you with <br class="hidden sm:block" />
          <span class="text-emerald-500">actionable insights</span>
        </h2>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
        <div
          v-for="insight in insightsData"
          :key="insight.id"
          class="md:col-span-6"
        >
          <InsightCard :insight="insight" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";
import InsightCard from "@/components/shared/InsightCard.vue";

import iconServerSideTracking from "@/assets/svg/icon-rocket.svg";
import iconDataIngestion from "@/assets/svg/icon-ingestion.svg";
import iconDataMonitoring from "@/assets/svg/icon-monitoring.svg";
import iconDashboards from "@/assets/svg/icon-dashboard.svg";

import imgServerSide from "@/assets/img/img-server-side.png";
// import imgDashboards from "@/assets/img/img-server-side.png";
import imgDashboards from "@/assets/img/data_dashboarding_new.png";
import imgDataIngestion from "@/assets/img/data_ingestion_new.png";
// import imgDataMonitoring from "@/assets/img/data_monitoring_nobg.png";
import imgDataMonitoring from "@/assets/img/data_monitoring_new.png";

const insightsData = ref([
  {
    id: 1,
    iconSvg: iconServerSideTracking,
    title: "SERVER SIDE TRACKING",
    description:
      "Recover up to 40% of lost conversion events by implementing server-side tracking, deduplication, and event enrichment",
    linkText: null,
    linkUrl: "#server-side-tracking-details",
    imageUrl: imgServerSide,
    imageAlt: "Illustration of server side tracking concepts",
  },
  {
    id: 2,
    iconSvg: iconDataIngestion,
    title: "DATA INGESTION",
    description:
      "Automate data collection from multiple sources (GA4, Meta, Shopify, etc.) into BigQuery for central storage.",
    linkText: null,
    linkUrl: null,
    imageUrl: imgDataIngestion,
    imageAlt: null,
  },
  {
    id: 3,
    iconSvg: iconDashboards,
    title: "DASHBOARDS",
    description:
      "Get clear, actionable reports in Looker Studio to track key metrics and optimize performance.",
    linkText: null,
    linkUrl: null,
    imageUrl: imgDashboards,
    imageAlt: "Illustration of a person looking at dashboards",
  },
  {
    id: 4,
    iconSvg: iconDataMonitoring,
    title: "DATA MONITORING",
    description:
      "Ensure data quality, detect anomalies, and alert for broken tracking or missing data.",
    linkText: null,
    linkUrl: null,
    imageUrl: imgDataMonitoring,
    imageAlt: null,
  },
]);
</script>

<style scoped>
/* Main section styling */
</style>
